import { render, staticRenderFns } from "./AIChat.vue?vue&type=template&id=a3d5a444&scoped=true"
import script from "./AIChat.vue?vue&type=script&lang=js"
export * from "./AIChat.vue?vue&type=script&lang=js"
import style0 from "./AIChat.vue?vue&type=style&index=0&id=a3d5a444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d5a444",
  null
  
)

export default component.exports